var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Data Adicional" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c("div", {
            staticStyle: {
              "letter-spacing": "0.02em",
              "white-space": "nowrap",
              overflow: "hidden",
              "text-overflow": "ellipsis",
              "margin-top": "16px"
            }
          }),
          _c(
            "div",
            { staticClass: "boton_crear" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "icon",
                  staticStyle: {
                    "padding-right": "20px",
                    display: "block",
                    margin: "13px 10px 0 auto",
                    height: "38px"
                  },
                  attrs: { color: "#ffe800" },
                  on: { click: _vm.guardar }
                },
                [
                  _c("span", { staticStyle: { color: "black" } }, [
                    _vm._v("Guardar")
                  ])
                ]
              )
            ],
            1
          )
        ]
      ),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c("ContenidoModal", [
        _c(
          "div",
          { attrs: { align: "center" } },
          [
            _vm.isTrack3
              ? _c(
                  "v-flex",
                  { attrs: { md10: "" } },
                  [
                    _c(
                      "v-card",
                      { staticClass: "rounded-card" },
                      [
                        _c(
                          "v-form",
                          {
                            ref: "form",
                            staticClass: "col-md-12",
                            attrs: { "lazy-validation": "" }
                          },
                          [
                            _c(
                              "v-container",
                              {
                                staticStyle: { padding: "30px 40px 50px 40px" },
                                attrs: { "grid-list-md": "" }
                              },
                              [
                                _c(
                                  "FormFieldsContainer",
                                  { attrs: { titulo: "Datos GPS" } },
                                  [
                                    _vm._t("prependInformacionGeneral"),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: { xs12: "", sm12: "", md12: "" }
                                      },
                                      [
                                        _c("v-text-field", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value:
                                                "required|max:20|numeroSerieUnico|alpha_num",
                                              expression:
                                                "'required|max:20|numeroSerieUnico|alpha_num'"
                                            }
                                          ],
                                          attrs: {
                                            "error-messages": _vm.errors.collect(
                                              "serie"
                                            ),
                                            "data-vv-name": "serie",
                                            label: "Nro. Serie",
                                            type: "text",
                                            min: "1",
                                            counter: 20,
                                            required: ""
                                          },
                                          model: {
                                            value: _vm.formFields.serie.value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields.serie,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression: "formFields.serie.value"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: { xs12: "", sm12: "", md12: "" }
                                      },
                                      [
                                        _c("v-select", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            items: _vm.marcasGps,
                                            "item-text": "nombre",
                                            "item-value": "id",
                                            label: "Marca de GPS",
                                            "error-messages": _vm.errors.collect(
                                              "marca"
                                            ),
                                            "data-vv-name": "marca",
                                            required: "",
                                            "no-data-text": "Sin resultados"
                                          },
                                          on: { change: _vm.changeMarca },
                                          model: {
                                            value:
                                              _vm.formFields.selectedTipoGps
                                                .value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields.selectedTipoGps,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formFields.selectedTipoGps.value"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: { xs12: "", sm12: "", md12: "" }
                                      },
                                      [
                                        _c("v-select", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            items: _vm.modelosGps,
                                            "item-text": "nombre",
                                            "item-value": "id",
                                            label: "Modelo de GPS",
                                            "error-messages": _vm.errors.collect(
                                              "modelo"
                                            ),
                                            "data-vv-name": "modelo",
                                            "no-data-text": "Sin resultados",
                                            required: ""
                                          },
                                          model: {
                                            value:
                                              _vm.formFields.selectedModelo
                                                .value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields.selectedModelo,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formFields.selectedModelo.value"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: { xs12: "", sm12: "", md12: "" }
                                      },
                                      [
                                        _c("v-text-field", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value:
                                                "required|max:15|IMEI|IMEIUnico",
                                              expression:
                                                "'required|max:15|IMEI|IMEIUnico'"
                                            }
                                          ],
                                          attrs: {
                                            "error-messages": _vm.errors.collect(
                                              "imei"
                                            ),
                                            "data-vv-name": "imei",
                                            label: "IMEI",
                                            type: "text",
                                            counter: 15,
                                            required: ""
                                          },
                                          model: {
                                            value: _vm.formFields.imei.value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields.imei,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression: "formFields.imei.value"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: { xs12: "", sm12: "", md12: "" }
                                      },
                                      [
                                        _c("v-select", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            items: _vm.estados,
                                            label: "Estado",
                                            "item-value": "id",
                                            "item-text": "nombre",
                                            "error-messages": _vm.errors.collect(
                                              "estado"
                                            ),
                                            "data-vv-name": "estado",
                                            required: "",
                                            "no-data-text": "Sin resultados",
                                            "persistent-hint": "",
                                            readonly: ""
                                          },
                                          model: {
                                            value: _vm.formFields.estado.value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields.estado,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formFields.estado.value"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("br"),
                    _c(
                      "v-card",
                      { staticClass: "rounded-card" },
                      [
                        _c(
                          "v-form",
                          {
                            ref: "form",
                            staticClass: "col-md-12",
                            attrs: { "lazy-validation": "" }
                          },
                          [
                            _c(
                              "v-container",
                              {
                                staticStyle: { padding: "30px 40px 50px 40px" },
                                attrs: { "grid-list-md": "" }
                              },
                              [
                                _c(
                                  "FormFieldsContainer",
                                  { attrs: { titulo: "Detalle SIM" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: { xs12: "", sm12: "", md12: "" }
                                      },
                                      [
                                        _c("v-text-field", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value:
                                                "required|numeroSimUnico|numeric|max:20",
                                              expression:
                                                "'required|numeroSimUnico|numeric|max:20'"
                                            }
                                          ],
                                          attrs: {
                                            "error-messages": _vm.errors.collect(
                                              "numSim"
                                            ),
                                            "data-vv-name": "numSim",
                                            label: "Número SIM",
                                            counter: 20,
                                            required: ""
                                          },
                                          model: {
                                            value:
                                              _vm.formFields.numeroSIM.value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields.numeroSIM,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formFields.numeroSIM.value"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: { xs12: "", sm12: "", md12: "" }
                                      },
                                      [
                                        _c("v-select", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            items: _vm.tiposSim,
                                            "item-text": "nombre",
                                            "item-value": "id",
                                            label: "Tipo SIM",
                                            "error-messages": _vm.errors.collect(
                                              "tipoSim"
                                            ),
                                            "data-vv-name": "tipoSim",
                                            required: ""
                                          },
                                          on: { change: _vm.changeTipoSIM },
                                          model: {
                                            value:
                                              _vm.formFields.selectedTipoSim
                                                .value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields.selectedTipoSim,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formFields.selectedTipoSim.value"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: { xs12: "", sm12: "", md12: "" }
                                      },
                                      [
                                        _c("v-autocomplete", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required|max:20",
                                              expression: "'required|max:20'"
                                            }
                                          ],
                                          attrs: {
                                            "error-messages": _vm.errors.collect(
                                              "cia"
                                            ),
                                            "data-vv-name": "cia",
                                            items: _vm.companiasTelco,
                                            color: "primary",
                                            clearable: true,
                                            "item-text": "nombre",
                                            "item-value": "id",
                                            label: "Cía. Telecomunicaciones",
                                            "no-data-text": "Sin resultados",
                                            required: ""
                                          },
                                          model: {
                                            value:
                                              _vm.formFields.selectedCia.value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields.selectedCia,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formFields.selectedCia.value"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: { xs12: "", sm12: "", md12: "" }
                                      },
                                      [
                                        _c("v-text-field", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                max: 15,
                                                numeric: true
                                              },
                                              expression:
                                                "{\n                      max: 15,\n                      numeric: true,\n                    }"
                                            }
                                          ],
                                          attrs: {
                                            "error-messages": _vm.errors.collect(
                                              "numeroTelefonico"
                                            ),
                                            "data-vv-name": "numeroTelefonico",
                                            label: "Teléfono Celular",
                                            placeholder: "56999999999",
                                            type: "text",
                                            counter: 15,
                                            required: ""
                                          },
                                          model: {
                                            value:
                                              _vm.formFields.numeroTelefonico
                                                .value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields.numeroTelefonico,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formFields.numeroTelefonico.value"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("br")
                  ],
                  1
                )
              : _c(
                  "v-flex",
                  { attrs: { md10: "" } },
                  [
                    _c(
                      "v-card",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasGps,
                            expression: "hasGps"
                          }
                        ],
                        staticClass: "rounded-card"
                      },
                      [
                        _c(
                          "v-form",
                          {
                            ref: "form",
                            staticClass: "col-md-12",
                            attrs: { "lazy-validation": "" }
                          },
                          [
                            _c(
                              "v-container",
                              {
                                staticStyle: { padding: "30px 40px 50px 40px" },
                                attrs: { "grid-list-md": "" }
                              },
                              [
                                _c(
                                  "FormFieldsContainer",
                                  {
                                    attrs: {
                                      titulo:
                                        "Agregue la marca y modelo del GPS"
                                    }
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: { xs12: "", sm12: "", md12: "" }
                                      },
                                      [
                                        _c("v-select", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            items: _vm.marcasGps,
                                            "item-text": "nombre",
                                            "item-value": "id",
                                            label: _vm.formFields2.marca.label,
                                            "error-messages": _vm.errors.collect(
                                              "marcaInt"
                                            ),
                                            "data-vv-name": "marcaInt",
                                            required: "",
                                            "no-data-text": "Sin resultados"
                                          },
                                          on: { change: _vm.changeMarca },
                                          model: {
                                            value: _vm.formFields2.marca.value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields2.marca,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formFields2.marca.value"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: { xs12: "", sm12: "", md12: "" }
                                      },
                                      [
                                        _c("v-select", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            items: _vm.modelosGps,
                                            "item-text": "nombre",
                                            "item-value": "id",
                                            label: _vm.formFields2.modelo.label,
                                            "error-messages": _vm.errors.collect(
                                              "modeloInt"
                                            ),
                                            "data-vv-name": "modeloInt",
                                            "no-data-text": "Sin resultados",
                                            required: ""
                                          },
                                          model: {
                                            value: _vm.formFields2.modelo.value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields2.modelo,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formFields2.modelo.value"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("br"),
                    _c(
                      "v-card",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasSim,
                            expression: "hasSim"
                          }
                        ],
                        staticClass: "rounded-card"
                      },
                      [
                        _c(
                          "v-form",
                          {
                            ref: "form",
                            staticClass: "col-md-12",
                            attrs: { "lazy-validation": "" }
                          },
                          [
                            _c(
                              "v-container",
                              {
                                staticStyle: { padding: "30px 40px 50px 40px" },
                                attrs: { "grid-list-md": "" }
                              },
                              [
                                _c(
                                  "FormFieldsContainer",
                                  {
                                    attrs: {
                                      titulo: "Agregue el número telefónico"
                                    }
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: { xs12: "", sm12: "", md12: "" }
                                      },
                                      [
                                        _c("v-text-field", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                max: 15,
                                                numeric: true
                                              },
                                              expression:
                                                "{\n                      max: 15,\n                      numeric: true,\n                    }"
                                            }
                                          ],
                                          attrs: {
                                            "error-messages": _vm.errors.collect(
                                              "numeroTelefonico"
                                            ),
                                            "data-vv-name": "numeroTelefonico",
                                            label: "Teléfono Celular",
                                            placeholder: "56999999999",
                                            type: "text",
                                            counter: 15,
                                            required: ""
                                          },
                                          model: {
                                            value:
                                              _vm.formFields2.numeroTelefonico
                                                .value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields2
                                                  .numeroTelefonico,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formFields2.numeroTelefonico.value"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("br")
                  ],
                  1
                )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }